import React from 'react';
var Anchor = React.memo(function (_a) {
    var anchorKey = _a.anchorKey, type = _a.type;
    return (
    // @ts-ignore
    React.createElement("div", { key: anchorKey, type: type, "data-hook": anchorKey }));
});
export default Anchor;
//# sourceMappingURL=Anchor.js.map